<template>
  <header class="shop-header">
    <Logo class="shop-header__logo" />
    <div class="shop-header__nav-buttons" v-if="!isOnePlanAvailable">
      <router-link
        v-if="isSkillDivePreSalePage"
        :to="{ name: 'shop' }"
        class="btn btn--secondary header__cta"
      >
        Back to shop
      </router-link>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Logo from '@/assets/icons/ine-logo.svg'

export default {
  name: 'ShopHeader',
  components: {
    Logo: { ...Logo, name: 'Logo' },
  },
  computed: {
    ...mapState({
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
    }),
    isSkillDivePreSalePage() {
      return this.$route.name === 'skill-dive'
    },
  },
}
</script>

<style lang="scss">
.shop-header {
  width: 100%;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: var(--charcoal-gradient);
  z-index: 2;
  display: flex;
  justify-content: space-between;
  font-family: var(--font-regular);
  padding: 20px;
  @include tablet {
    padding: 20px 50px;
  }
  &__logo {
    width: 85px;
  }
  &__nav-buttons {
    display: none;
    gap: 10px;
    @include mobile {
      display: flex;
    }
  }
}
</style>
